import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
    selectedChannels: {},
};

const channelSelectionSlice = createSlice({
    name: 'channelSelectionData',
    initialState,
    reducers: {
        toggleChannelSelection(state, action) {
            const channel = action.payload;
            const id = channel.channelId;
            if (state.selectedChannels[id]) {
                delete state.selectedChannels[id];
            } else {
                state.selectedChannels[id] = channel;
            }
        },
        deleteChannelSelection(state, action) {
            const channel = action.payload;
            const id = channel.channelId;
            if (state.selectedChannels[id]) {
                delete state.selectedChannels[id];
            }
        },
        resetChannelSelection(state) {
            state.selectedChannels = {};
        },
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { toggleChannelSelection, resetChannelSelection, deleteChannelSelection } = channelSelectionSlice.actions;
export default channelSelectionSlice.reducer;
